import React, { ChangeEvent, Fragment, ReactNode } from 'react';

import { connect } from 'react-redux';

import { AppState, Actions, store, IPageState, DisplayState } from 'appredux';


import { createTheme, withStyles, WithStyles } from '@material-ui/core/styles';
import { Theme } from "@material-ui/core/styles";
import theme from 'themes';
import Typography from '@material-ui/core/Typography';


import { Tooltip, Icon, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, FormControl, InputAdornment, IconButton } from '@material-ui/core';

import  { SelectChangeEvent } from '@mui/material/Select';
import Select from '@material-ui/core/Select';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@material-ui/core/TextField';
import { ThemeProvider } from '@mui/material';
import { capitalizeFirstLetter, sendErrorLog, stacjonarnyPrefix } from 'common/helpers';

import DialpadIcon from '@mui/icons-material/Dialpad';
import Klawiatura from './Klawiatura';
import { ManagerService, telefonService } from 'api';
import Loader from 'common/Loader';

let orangeTheme = createTheme({
  palette: {
    primary: {
      main: '#0052cc',
    },
    secondary: {
      main: '#edf2ff',
    },
  },
  overrides: {
    MuiButton: {
      root:{
        textTransform: "none" as "none"
      },
      containedSizeLarge: {
        fontSize: "1rem"
      }
    },
    MuiOutlinedInput: { 
      notchedOutline: {
        borderColor: "red",
        borderRadius: "4px"
      }
    },
    MuiSelect: {
      root: {
       // padding: "6px 14px", textAlign: "left", fontSize: "13px", color: "red"
      },
      outlined: {
       // padding: "6px 14px", textAlign: "left", fontSize: "13px", color: "red"
      },
      selectMenu: {
        fontWeight: 400
      }
    },
  },

});

interface DialogProps extends WithStyles<typeof styles> {
    page: IPageState,
    windowWidth: number,
    open: boolean,
    send: () => Promise<void>,
    close: () => void,
}

interface DialogState {
    dzien: string,
    termin: number,

    telefon: string,
    imie: string,
    openKlawiatura1: boolean,
    ladowanie: boolean,
    openInfo: boolean,
    openInfoError: boolean,
    phoneError: string,
    nameError: string,
    showError: boolean
}

let godziny = [8,9,10,11,12,13,14,15,16,17,18,19,20,]

class DialogKontakt extends React.Component<DialogProps, DialogState>  {
    stylInputaIlePokoi: React.CSSProperties = { padding: "6px 14px", textAlign: "left", fontSize: "13px" };
    stylInputaTelefon: React.CSSProperties = { padding: "6px 6px 6px 14px", textAlign: "left", fontSize: "13px" };

    //PM 2021-09-17
    constructor(props: DialogProps) {

      let godz = new Date().getHours() + 1
      let dzien = "dzisiaj"
      if(godz > 20){
        godz = 8
        dzien = "jutro"
      }
      

        super(props, {});
        this.state = {
            dzien: dzien,
            termin: godz,

            telefon: "",
            imie: "",
            openKlawiatura1: false,
            ladowanie: false,
            openInfo: false,
            openInfoError: false,
            phoneError: "",
            nameError: "",
            showError: false
        }
    }

    handleChangeDzien = (event: ChangeEvent<{ name?: string | undefined; value: unknown; }>, child: ReactNode) => {
        this.setState({dzien: event.target.value as string});
      };

    handleChangeTermin = (event: ChangeEvent<{ name?: string | undefined; value: unknown; }>, child: ReactNode) => {
        this.setState({termin: event.target.value as number});
      };


      wyslijSms = async () => {
        try {
          this.setState({ showError: true })
          let error = false
          let tel = this.state.telefon
          let name = this.state.imie
          if (tel.length < 9) {
            this.setState({ phoneError: "Niepoprawny numer" })
            error = true
          } 
          if (tel === "") {
            this.setState({ phoneError: "Pole wymagane" })
            error = true
          }
          let sta = stacjonarnyPrefix(tel)
          if (sta !== "") {
            this.setState({ phoneError: "Niepoprawny numer" })
            error = true
          }
          if (name === "") {
            this.setState({ nameError: "Pole wymagane" })
            error = true
          }

          if(!error){

            let res = await telefonService.sprawdzNrTelefonu({ nrTelefonu: tel }, {})

            if (Number(res.result) > 0) {
              this.setState({ phoneError: "" })
            } else {
              this.setState({ phoneError: "Niepoprawny numer" })
              error = true
            }

          }
         
      
      
    

          if(!error){
            this.setState({ ladowanie: true })
            let wiadomosc = `Jestem na Panstwa stronie\nChce porozmawiac o systemie\nProsze o kontakt telefoniczny\nNajlepszy dla mnie termin to ${this.state.dzien} o godz. ${this.state.termin}:00\nPozdrawiam, ${this.state.imie}`

            let dane = {
              mobileId: "4-FCM-11",
              mobileNr: "0",
              nadawcaId: "hotel-TEST",
              przesylkaId: "0",
              tekst: wiadomosc,
              telNr: this.state.telefon,
            }

            let res = await ManagerService.smsWyslij({ dane: dane })

            if (res.result[0] > 0) {
              this.setState({ openInfo: true })
            } else {
              this.setState({ openInfoError: true })
            }

            //this.setState({ ...this.state, openSmsInfo: false });
            //this.handleModalClose();
            this.setState({ ladowanie: false })
          }

        } catch (error) {
            console.log(error);
            this.setState({ ladowanie: false})
            await sendErrorLog( "0", "-1", 'vscSms/fcm/smsWyslijPrzesylkaId')
            await store.dispatch(Actions.pageState.addFcmLogMessage("vscSms/fcm/smsWyslijPrzesylkaId", 2))
        }
    }

    closeInfo = () => {
      this.setState({openInfo: false})
    }
    closeInfoError = () => {
      this.setState({openInfoError: false})
    }

     
    // handleChangeDzien = (event: SelectChangeEvent) => {
    //     this.setState({dzien: event.target.value as string});
    //   };

    // handleChangeTermin = (event: SelectChangeEvent) => {
    //     this.setState({termin: event.target.value as string});
    //   };

    // componentDidUpdate(prevProps: DialogProps) {
    //     if(this.props.page.openDialogError !== prevProps.page.openDialogError){
    //         this.setState({open: true})
    //     }
    // }

    // closeDialog = () => {
    //     this.setState({ open: false });
    // };

    setOpenKlawiatura1 = () => {
      this.setState({openKlawiatura1: true})
    }
    setCloselawiatura1 = (focusNext: boolean) => {
      this.setState({openKlawiatura1: false})
     
    } 
    setTelefonKlawiatura = (tel: string) => {
      this.setState({ telefon: tel })
    }

      onChangeTelefon = (event: React.ChangeEvent<{ name?: string; value: unknown; }>) => {
        let val = String(event.target.value)
        if (val.length < 9 && this.state.showError) this.setState({ phoneError: "Niepoprawny numer" })
        if (val === "" && this.state.showError) this.setState({ phoneError: "Pole wymagane" })
        if (val.length >= 9) this.setState({ phoneError: "" })
        let sta = stacjonarnyPrefix(val)
          if (sta !== "" && this.state.showError) {
            this.setState({ phoneError: "Niepoprawny numer" })
          }
        this.setState({ telefon: val })
      }

      onChangeImie = (event: React.ChangeEvent<{ name?: string; value: unknown; }>) => {
        let val = String(event.target.value)
        if (val === "" && this.state.showError) this.setState({ nameError: "Pole wymagane" })
        if (val !== "" ) this.setState({ nameError: "" })
        this.setState({ imie: capitalizeFirstLetter(val) })
      }

      preventKeys = (e: React.KeyboardEvent<HTMLDivElement>) => {
        if (e.key === "e" || e.key === "E" || e.key === "-" || e.key === "+") {
          e.preventDefault()
        }
    }


    render() {
        const classes = this.props.classes;

        let phoneError = this.state.phoneError !== ""
        let nameError = this.state.nameError !== ""

        let imie = this.state.imie
        if(imie === "") imie = "Moje imię"
       
        return (
            <>
            {this.state.ladowanie ? <Loader /> : null}
                {/* <Dialog
                    //disableEscapeKeyDown
                    maxWidth="sm"
                    open={this.props.open}
                    onEscapeKeyDown={this.props.close}
                    onBackdropClick={this.props.close}
                    fullWidth
                > */}
                
                    {/* <DialogTitle disableTypography >
                        <Typography gutterBottom variant="h6" component="h2" align='center'
                            className={`${classes.headline} ${classes.primary}`}>
                            <b style={{ textTransform: "lowercase" }}>{'kontakt'}</b>
                        </Typography>
                        <hr style={{ marginTop: "10px", borderBottom: "0px" }} />
                    </DialogTitle> */}
                    <DialogContent style={{paddingBottom: "20px"}}>
                        {/* <div style={{display: "flex"}}>
                        <div style={{margin: "auto"}}> */}
                        {/* style={{paddingLeft: "12px"}} */}
                        <div style={{display: "flex", justifyContent: "center"}} >
                        <div style={{width: "500px"}}> {/*className={classes.shadow}*/}

                        <DialogContentText className={classes.dialogContentText} >
                            {"Jestem na Panstwa stronie"}
                        </DialogContentText>
                        <DialogContentText className={classes.dialogContentText} >
                            {"Chce porozmawiac o systemie"}
                        </DialogContentText>
                        <DialogContentText className={classes.dialogContentText} >
                            {"Prosze o kontakt telefoniczny"}
                        </DialogContentText>
                        <DialogContentText className={classes.dialogContentText} >
                            {"Najlepszy dla mnie termin to "} <b>{this.state.dzien}</b>{" o godz. "}<b>{this.state.termin + ":00"}</b>
                        </DialogContentText>
                        <DialogContentText className={classes.dialogContentText} >
                            {"Pozdrawiam, "}<b>{imie}</b>
                        </DialogContentText>
                        {/* </div>
                        </div> */}
                        {/* </div>
                        </div> */}

                        <DialogContentText className={classes.dialogContentText} >
                        </DialogContentText>
                        <DialogContentText className={classes.dialogContentText} >
                        </DialogContentText>

                        {/* <div style={{display: "flex", justifyContent: "center"}} >
                        <div className={classes.shadow} style={{width: "400px", paddingLeft: 0, paddingRight: 0}}> */}
                          <div style={{margin: "auto", width: "fit-content"}}>

                        <ThemeProvider theme={theme}>
                        <FormControl //style={{paddingLeft: "24px"}}
                                variant="outlined"  margin="dense" fullWidth
                                className={classes.formControl}
                              >
                                  <label className={`${classes.label} ${classes.labelColor}`} >Wybierz dzień</label>
                                  <Select
                                    color='secondary'
                                    value={this.state.dzien}
                                    onChange={this.handleChangeDzien}

                                    classes={{ selectMenu: classes.select,  }}
                                    
                                    className={classes.inputWidth} 
                                    variant="outlined"

                                >
                                    <MenuItem value={"dzisiaj"} className={classes.menuItem}>dzisiaj</MenuItem>
                                    <MenuItem value={"jutro"} className={classes.menuItem}>jutro</MenuItem>
                                    <MenuItem value={"pojutrze"} className={classes.menuItem}>pojutrze</MenuItem>
                                </Select>
                              </FormControl>
                        <FormControl //style={{paddingLeft: "24px"}}
                                variant="outlined"  margin="dense" fullWidth
                                className={classes.formControl}
                              >
                                  <label className={`${classes.label} ${classes.labelColor}`} >Wybierz godzinę</label>
                                  <Select
                                    color='secondary'
                                    value={this.state.termin}
                                    //label="dzień"
                                    onChange={this.handleChangeTermin}
                                    classes={{ selectMenu: classes.select }}
                                    className={classes.inputWidth} 
                                    variant="outlined"
                                >
                                  {godziny.map(x => (
                                    <MenuItem value={x} className={classes.menuItem}>{x + ":00"}</MenuItem>
                                  ))}
                                    {/* <MenuItem value={"rano"} className={classes.menuItem} >rano</MenuItem>
                                    <MenuItem value={"południe"} className={classes.menuItem}>południe</MenuItem>
                                    <MenuItem value={"wieczór"}className={classes.menuItem} >wieczór</MenuItem> */}
                                </Select>
                              </FormControl>
                              </ThemeProvider>

                        <DialogContentText className={classes.dialogContentText} >
                        </DialogContentText>

                        <FormControl //style={{paddingLeft: "24px"}}
                                variant="outlined"  margin="dense" fullWidth
                                className={classes.formControl}
                              >
                                  <label className={`${classes.label} ${classes.labelColor}`} >Wpisz swój nr telefonu</label>
                                  <TextField
                                    autoFocus
                                    color='secondary'
                                    id={"0"}
                                    type={'number'}
                                    error={phoneError}
                                    helperText={this.state.phoneError}
                                    className={classes.inputWidth} 
                                    //style={this.props.style}
                                    variant="outlined"
                                    inputProps={{ style: this.stylInputaTelefon }}
                                    InputProps={{ classes: { input: `${classes.textField} ${classes.textFieldEnabled}`}, 
                                    endAdornment: ( <InputAdornment position="start" style={{ padding: "0" }} >

                                    <IconButton id="klawiaturaIcon1"
                                      aria-label="more"
                                      aria-controls="long-menu"
                                      aria-haspopup="true"
                                      onClick={this.setOpenKlawiatura1}
                                      style={{ padding: "4px", marginRight: "-14px" }}
                                    >
                                        <DialpadIcon style={{ fontSize: "1rem" }} />
                                    </IconButton>
                                    <Klawiatura open={this.state.openKlawiatura1} number={Number(this.state.telefon)} setNumber={this.setTelefonKlawiatura} close={this.setCloselawiatura1} title={"wpisz telefon"} placeholder="606 257 683" phoneMode max={9} error={""}/>
                                  </InputAdornment>) }}
                                    value={this.state.telefon.toString()}
                                    //disabled={this.props.disabled}
                                    onKeyDown={this.preventKeys}
                                    onChange={this.onChangeTelefon}
                                    placeholder='606 257 683'
                                    
                                   

                                  />
                              </FormControl>
                        <FormControl //style={{paddingLeft: "24px"}}
                                variant="outlined"  margin="dense" fullWidth
                                className={classes.formControl}
                              >
                                <ThemeProvider theme={orangeTheme}>
                                  <label className={`${classes.label} ${classes.labelColor}`} >Wpisz swoje imię</label>
                                  
                                  <TextField
                                    id={"1"}
                                    //type={'number'}
                                    color='secondary'
                                    className={classes.inputWidth} 
                                    //style={this.props.style}
                                    error={nameError}
                                    helperText={this.state.nameError}
                                    variant="outlined"
                                    inputProps={{ style: this.stylInputaIlePokoi, }}
                                    InputProps={{ classes: { input: `${classes.textField} ${classes.textFieldEnabled}` }, }}
                                    value={capitalizeFirstLetter(this.state.imie)}
                                    //disabled={this.props.disabled}
                                    //onKeyDown={this.preventKeys}
                                    onChange={this.onChangeImie}
                                    placeholder='Moje imię'
                                  />
                                  </ThemeProvider>
                              </FormControl>
                              </div>

                              <DialogContentText className={classes.dialogContentText} >
                              </DialogContentText>

                              <DialogContentText style={{ textAlign: "center", paddingTop: "20px" }} >
                                <Button variant="outlined" color="primary" size="large" className={classes.button}
                                  onClick={this.wyslijSms} style={{}}>
                                  <b>wyślij sms</b>
                                </Button>
                              </DialogContentText>

                        </div>
                        </div>

                        <DialogContentText className={classes.dialogContentText} >
                              </DialogContentText>
                    
                       
                    </DialogContent>
                    
                    {/* <DialogActions>
                        <Button variant="contained" color="primary" size="small" className={classes.button}
                            onClick={this.props.send}>
                            <b>wyślij sms</b>
                        </Button>
                        <Button variant="outlined" color="primary" size="small" className={classes.button}
                            onClick={this.props.close}>
                            <b>wróć</b>
                        </Button>
                    </DialogActions> */}
                {/* </Dialog> */}

                <Dialog
                    //disableEscapeKeyDown
                    maxWidth="xs"
                    open={this.state.openInfo}
                    onEscapeKeyDown={this.closeInfo}
                    onBackdropClick={this.closeInfo}
                    fullWidth
                >
                    <DialogTitle disableTypography >
                        <Typography gutterBottom variant="h6" component="h2"
                            className={`${classes.primary}`}>
                            <b style={{ textTransform: "lowercase" }}>{'sukces'}</b>
                        </Typography>
                        <hr style={{ marginTop: "10px", borderBottom: "0px" }} />
                    </DialogTitle>
                    <DialogContent style={{paddingBottom: "20px"}}>
                        <DialogContentText  >
                            {"Sms został wysłany"}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button variant="outlined" color="primary" size="small"
                            onClick={this.closeInfo}>
                            <b>wróć</b>
                        </Button>
                    </DialogActions> 
                </Dialog>
                <Dialog
                    //disableEscapeKeyDown
                    maxWidth="xs"
                    open={this.state.openInfoError}
                    onEscapeKeyDown={this.closeInfoError}
                    onBackdropClick={this.closeInfoError}
                    fullWidth
                >
                    <DialogTitle disableTypography >
                        <Typography gutterBottom variant="h6" component="h2" color="error"  >
                            <b style={{ textTransform: "lowercase" }}>{'porażka'}</b>
                        </Typography>
                        <hr style={{ marginTop: "10px", borderBottom: "0px" }} />
                    </DialogTitle>
                    <DialogContent style={{paddingBottom: "20px"}}>
                        <DialogContentText  >
                            {"Sms nie został wysłany"}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button variant="outlined" color="secondary" size="small"
                            onClick={this.closeInfoError}>
                            <b>wróć</b>
                        </Button>
                    </DialogActions> 
                </Dialog>
            </>

        );
    }
}

const styles = (theme: Theme) => ({
    primary: {
        color: theme.palette.primary.main
      },
      secondary: {
        color: theme.palette.secondary.main
      },
      error: {
          color: "rgb(244, 67, 54)"
      },
      paddingBottom0: {
        paddingBottom: 0
      },
      headline: {
        //fontFamily: "\"'Open Sans'\", sans-serif",
        lineHeight: "20px",
        fontSize: "15px",
        //fontWeight: 600
      },
      dialogContentText: {
        //color: theme.palette.text.secondary,
        color: theme.palette.primary.main,
        //whiteSpace: "pre" as "pre",
        minHeight: "12px",
        marginBottom: '6px',
        fontSize: "15px",
        textAlign: "center" as "center"
      },
      button: {
        textTransform: "none" as "none",
        fontSize: "14px",
        width: "200px",
        borderRadius: "0px",

        color: "white",
        border: "2px solid lavender",
        backgroundColor: "rgb(255, 165, 0)",
         "&:hover": {
          background: "rgb(178, 115, 0)",
          border: "2px solid lavender",
        },
    },

    inputWidth: {
        //width: "15%",
        width: "160px",
        display: "inline-flex" as "inline-flex",
        "@media (max-width: 600px)": {
          width: '130px', 
        }
      },
      textField: {
        //color: "rgb(0, 0, 0)",
        //color: theme.palette.primary.main,
        color: theme.palette.secondary.main,
        //color: 'seagreen',
        padding: "8px 14px",
        fontSize: '16px',
        float: "left" as "left",
        textAlign: "left" as "left",
        fontWeight: "normal" as "normal", 
        //width: "120px"
        
      },
      textFieldDisabled: {
        color: theme.palette.primary.main,
      },
      textFieldEnabled: {
        //color: "orange",
        //color: theme.palette.primary.main,
        color: theme.palette.secondary.main,
        //fontWeight: "bold" as "bold"
      },

    border: {
      //border: "1px solid lavender",
      // "&:hover": {
      //   borderColor: "lavender !important",
      //   border: "2px solid lavender !important",
      // },
    },

      select: {
        //color: "rgb(0, 0, 0)",
        //color: theme.palette.primary.main,
        color: theme.palette.secondary.main,
        //color: 'seagreen',
        padding: "4px 14px", fontSize: "13px", 
        //padding: "8px 14px",
        //fontSize: '16px',
        float: "left" as "left",
        textAlign: "left" as "left",
        fontWeight: "normal" as "normal", 
        //width: "120px"
        //width: "clac(100% + - 164px)"
        
      },

      label: {
        //color: theme.palette.primary.main,
        //color: theme.palette.text.secondary,
        //fontFamilly: "sans-serif",
        //fontSize: "small"
        fontSize: "13px",
        fontFamily: "\"Arial\", \"Helvetica\", sans-serif",
        lineHeight: "20px",
        fontWeight: "bold" as "bold", 
        //fontWeight: theme.typography.body2.fontWeight,
        //paddingLeft: "20px",
        //padding: "7px 0 4px",
        marginRight: "10px",
        width: "145px",
       // width: "calc(100% + -85px)",
        display: "inline-block" as "inline-block"
      },
     labelColor: {
        //color: theme.palette.text.secondary,
        color: theme.palette.primary.main,
      },
      formControl: {
        //display: "block",
        //paddingBottom: "35px"
        marginTop: "0px", //4px
        
        //display: "inline-flex" as "inline-flex",
        display: "flex" as "flex",
        alignItems: "center" as "center",
        flexDirection: "row" as "row",   
    },
    menuItem: {
      fontSize: "13px !important"  
    },
    shadow: {
      boxShadow: "0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)",
      padding: "18px 15px 15px 20px",
      borderRadius: "4px"
    }

});

const mapStateToProps = (state: AppState) => ({
    page: state.pageState,
});

export default connect(mapStateToProps)(withStyles(styles)(DialogKontakt));

